import { Button } from 'components';
import { theme } from 'configs/styled';
import { FormikProps, FormikValues } from 'formik';
import { useQueryParams } from 'hooks/useQueryParams';
import React, { useEffect, useState } from 'react';
import { authenticationService } from 'services/driverPortal';
import ConfirmLogoutModal from './ConfirmLogoutModal';

interface ILogoutButton {
  formik?: FormikProps<FormikValues>;
}

const LogoutButton: React.FC<ILogoutButton> = props => {
  const { formik } = props;
  const { search, pushUrl } = useQueryParams();
  const [visible, setVisible] = useState(false);
  const [dirty, setDirty] = useState(formik?.dirty || false);

  const handleClickLogout = async () => {
    if (!dirty) {
      await authenticationService.logout();
      pushUrl('/login', search);
    }
    setVisible(true);
  };

  const handleCancel = (visibleModal: boolean) => {
    setVisible(visibleModal);
  };

  useEffect(() => {
    if (!formik) return;
    const { dirty, isSubmitting } = formik;

    const isDirty = !isSubmitting && dirty;
    setDirty(isDirty);
  }, [formik, dirty]);

  return (
    <>
      <Button
        style={{
          fontFamily: theme.fonts.NotoSansTh,
          fontWeight: theme.fontWeight.regular,
          fontStyle: 'normal',
          fontSize: theme.fontSize.xs,
          lineHeight: '22px',
          color: theme.palettes.black85,
        }}
        onClick={handleClickLogout}
      >
        ออกจากระบบ
      </Button>
      {visible && (
        <ConfirmLogoutModal
          visible={dirty}
          onCancel={handleCancel}
          formik={formik}
        />
      )}
    </>
  );
};

export default LogoutButton;
